/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoWaitSpinnerController {
    /** @ngInject */
    constructor(waitSpinnerService, $log) {
        this.waitSpinnerService = waitSpinnerService;
        $log.debug('Controller \'GmaoWaitSpinner\' loaded');
    }

    isVisible() {
        return this.waitSpinnerService.isVisible();
    }
}

export const gmaoWaitSpinnerComponent = {
    template: require('./gmao-wait-spinner.html'),
    controller: GmaoWaitSpinnerController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoWaitSpinner.js